import { Outlet } from "react-router";

import { usePatientLayoutContext } from "../layouts/patient";

export default function PatientIndex() {
  const context = usePatientLayoutContext();
  return <Outlet context={context} />;
}
